import { BehaviorSubject, Observable, Subject } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { Injectable } from "@angular/core";
import { endpoints } from "../_config/url-endpoint";
import { VerificationCodeTypeEnum } from "../_config/config";
/**
 *
 *
 * @export
 * @class DriverServices
 */
@Injectable({
  providedIn: "root",
})
export class DriverServices {
  private saveDriverVal = new Subject<any>();
  private storageKey = "myDataDriver";
  private dataSource = new BehaviorSubject<string>(
    localStorage.getItem(this.storageKey) || "initial value"
  );
  public data = this.dataSource.asObservable();

  /**
   * Creates an instance of DriverServices.
   *
   * @param {HttpClient} http
   * @memberof DriverServices
   */
  constructor(private http: HttpClient) {
    this.data.subscribe((value) => {
      localStorage.setItem(this.storageKey, value);
    });
  }

  /**
   * Get all drivers
   *
   * @param {*} queryString
   * @returns {Observable<any>}
   * @memberof DriverServices
   */
  getChauffer(queryString): Observable<any> {
    let url = `${endpoints.driverPage.getChaufferUrl}?${queryString}`;
    return this.http.get(url);
  }
  //   getChauffer(queryString): Observable<any> {
  //   let url = `${endpoints.driverPage.driverAnalyticsUrl}?${queryString}`;
  //   return this.http.get(url);
  // }

  getRegisteredDrivers(queryString): Observable<any> {
    let url = `${endpoints.driverPage.driverRegisteredAnalyticsUrl}?${queryString}`;
    return this.http.get(url);
  }

  getOnboardingDrivers(queryString): Observable<any> {
    let url = `${endpoints.driverPage.driverOnboardingAnalyticsUrl}?${queryString}`;
    return this.http.get(url);
  }

  getRegisteredDriversSummary(queryString): Observable<any> {
    let url = `${endpoints.driverPage.driverRegisteredSummaryUrl}?${queryString}`;
    return this.http.get(url);
  }

  getOnboardingDriversSummary(queryString): Observable<any> {
    let url = `${endpoints.driverPage.driverOnboardingSummaryUrl}?${queryString}`;
    return this.http.get(url);
  }
  getChaufferCount(tenantId): Observable<any> {
    let tenantUrlString = "";
    if (tenantId) {
      tenantUrlString = `?tenantId=${tenantId}`;
    }
    const url = `${endpoints.driverPage.getChaufferCountUrl}${tenantUrlString}`;
    return this.http.get(url);
  }

  downloadFile(queryString): Observable<any> {
    const url = `${endpoints.driverPage.getChaufferDownloadUrl}?${queryString}`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.get(url, { headers, responseType: "blob" });
  }

  downloadRegisteredDrivers(queryString): Observable<any> {
    const url = `${endpoints.driverPage.driverRegisteredDownloadUrl}?${queryString}`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.get(url, { headers, responseType: "blob" });
  }

  downloadOnboardingDrivers(queryString): Observable<any> {
    const url = `${endpoints.driverPage.driverOnboardingDownloadUrl}?${queryString}`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.get(url, { headers, responseType: "blob" });
  }

  createDriver(body): Observable<any> {
    return this.http.post(endpoints.driverPage.driverUrl, body);
  }

  // getDriver(driverId): Observable<any> {
  //   let url = `${endpoints.driverPage.driverUrl}/${driverId}`;
  //   return this.http.get(url);
  // }
 getDriver(driverId): Observable<any> {
    let url = `${endpoints.driverPage.driverDetailUrl}/${driverId}`;
    return this.http.get(url);
  }

  getDriverRating(driverId): Observable<any> {
    // Call users/v1/driver endpoint to get driver rating
    let url = `${endpoints.driverPage.driverUrl}/${driverId}`;
    return this.http.get(url);
  }

  getStatusActionHistory(driverId): Observable<any> {
    // Fetch driver status action history from activation logs
    // API uses query parameter: /admin/activation-logs?driverId={driverId}
    let params = new HttpParams().set('driverId', driverId);
    return this.http.get(endpoints.driverPage.statusActionHistoryUrl, { params });
  }

  updateDriver(driverId, body): Observable<any> {
    let url = `${endpoints.driverPage.driverUrl}/${driverId}`;
    return this.http.put(url, body);
  }

  assignCar(body): Observable<any> {
    return this.http.post(endpoints.driverPage.assignCarUrl, body);
  }

  changeStatus(driverId, body): Observable<any> {
    let url = `${endpoints.driverPage.changeStatusUrl}/${driverId}`;
    return this.http.post(url, body);
  }
   actionDriverStatus(body): Observable<any> {
    return this.http.post(endpoints.driverPage.actionUrl , body);
  }

  changeState(driverId, body): Observable<any> {
    let url = `${endpoints.driverPage.changeStateByAdmin}/${driverId}`;
    return this.http.post(url, body);
  }

  performanceDriver(driverId, body): Observable<any> {
    let url = `${endpoints.driverPage.performanceUrl}/${driverId}`;
    return this.http.post(url, body);
  }

  workingDriver(driverId, body): Observable<any> {
    let url = `${endpoints.driverPage.workingUrl}/${driverId}`;
    return this.http.post(url, body);
  }

  activeChauffeurs(queryString): Observable<any> {
    let query = "";
    if (queryString) {
      query = `?${queryString}`;
    }
    let url = `${endpoints.driverPage.activeChauffer}${query}`;
    return this.http.get(url);
  }

  activityDriver(driverId, body): Observable<any> {
    let url = `${endpoints.driverPage.activityUrl}/${driverId}`;
    return this.http.post(url, body);
  }

  earningsDriver(driverId, body): Observable<any> {
    let url = `${endpoints.driverPage.earningsUrl}/${driverId}`;
    return this.http.post(url, body);
  }

  selectedValue$ = this.dataSource.asObservable();

  getData(row: any = []) {
    this.dataSource.next(row);
    localStorage.setItem(this.storageKey, JSON.stringify(row));
  }

  public setRefreshDriver(data: any) {
    this.saveDriverVal.next({ result: data });
  }

  public getRefreshDriver(): Observable<any> {
    return this.saveDriverVal.asObservable();
  }

  getAcceptanceRate(body): Observable<any> {
    return this.http.post(endpoints.driverPage.acceptanceRateUrl, body);
  }

  assignChauffeur(body): Observable<any> {
    let url = `${endpoints.allBookings.assignChauffeurUrl}`;
    return this.http.post(url, body);
  }

  reject(body): Observable<any> {
    let url = `${endpoints.allBookings.rejectUrl}`;
    return this.http.post(url, body);
  }

  /**
   * Enable notify
   *
   * @param {string} tripId
   * @returns {Observable<any>}
   * @memberof DriverServices
   */
  enableNotify(tripId: string): Observable<any> {
    let url = `${endpoints.allBookings.enableNotifyUrl}/${tripId}`;
    return this.http.post(url, {});
  }

  validateChauffeur(tripId, chauffeurId): Observable<any> {
    let url = `${endpoints.allBookings.validateChauffeurUrl}/${tripId}/${chauffeurId}`;
    return this.http.get(url);
  }

  /**
   * Api request to get the trip hot zones
   *
   * @param {*} tenantId
   * @returns {Observable<any>}
   * @memberof DriverServices
   */
  fetchHotZonesForChauffeurs(tenantId): Observable<any> {
    let tenantUrlString = "";
    if (tenantId) {
      tenantUrlString = `?tenantId=${tenantId}`;
    }
    const url = `${endpoints.fleet.hotZones}${tenantUrlString}`;
    return this.http.get(url);
  }

  /**
   * Api request to get the trip hot zones
   *
   * @param {*} tenantId
   * @returns {Observable<any>}
   * @memberof DriverServices
   */
  fetchCategoryFleetCount(tenantId: string = null): Observable<any> {
    let tenantUrlString = "";
    if (tenantId) {
      tenantUrlString = `?tenantId=${tenantId}`;
    }
    const url = `${endpoints.fleet.categoryCount}${tenantUrlString}`;
    return this.http.get(url);
  }

  /**
   * Api request to get the fleet count per tenant (optional)
   *
   * @param {string} [tenantId=null]
   * @returns {Observable<any>}
   * @memberof DriverServices
   */
  fleetCount(tenantId: string = null): Observable<any> {
    let url = `${endpoints.driverPage.fleetCount}`;
    if (tenantId) {
      url = `${url}?tenantId=${tenantId}`;
    }
    return this.http.get(url);
  }

  getChauffeurOtpDetails(userId) {
    let url = `${endpoints.driverPage.otpDetails}/${userId}/DRIVER_APP/${VerificationCodeTypeEnum.TOKEN_GENERATION}`;
    return this.http.get(url);
}

tripDetailsByDriverId(queryString): Observable<any> {
  let query = "";
  if (queryString) {
    query = `?${queryString}`;
  }
  let url = `${endpoints.driverPage.driverTripDetailsUrl}${query}`;
  return this.http.get(url);
}
 updateIdentityDocuments(formData: FormData): Observable<any> {
    return this.http.post(endpoints.driverPage.updateIdentityDocuments, formData);
  }

  rejectionReason(driverId: string, payload: any): Observable<any> {
    const url = `${endpoints.driverPage.rejectionReasonUrl}/${driverId}`;
    return this.http.post(url, payload);
  }

  getRejectionNotes(driverId: string): Observable<any> {
    const url = `${endpoints.driverPage.rejectionNotesUrl}/${driverId}`;
    return this.http.get(url);
  }

  chauffeursInvitation(body): Observable<any> {
    return this.http.post(endpoints.driverPage.chauffeursInvitationUrl, body);
  }
  chauffeursInvitationRevoke(invitationId: string): Observable<any> {
    
    const body = { status: 'REVOKED' };
    return this.http.put(`${endpoints.driverPage.chauffeursInvitationRevokeUrl}/${invitationId}/status`, body);
  }

  /**
   * Accept a driver invitation
   * @param invitationId - The invitation ID to accept
   * @returns Observable with the response
   */
  acceptInvitation(invitationId: string): Observable<any> {
    const url = `${endpoints.driverPage.chauffeursInvitationAcceptUrl}/${invitationId}/accept`;
    return this.http.post(url, { status: 'ACCEPTED' });
  }

  /**
   * Reject a driver invitation
   * @param invitationId - The invitation ID to reject
   * @returns Observable with the response
   */
  rejectInvitation(invitationId: string): Observable<any> {
    const url = `${endpoints.driverPage.chauffeursInvitationRejectUrl}/${invitationId}/reject`;
    return this.http.post(url, { status: 'REJECTED' });
  }

  driverDocumentConfig(tenantId?: string): Observable<any> {
   
    const url = `${endpoints.driverPage.driverDocumentConfig}/tenant/${tenantId}`;
    return this.http.get(url);
  }

  updateDriverDetails(driverId: string, formData: FormData): Observable<any> {
    const url = `${endpoints.driverPage.driverDetailsUrl}/${driverId}`;
    return this.http.put(url, formData);
  }

  updateDriverPhone(driverId: string, body: { countryCode: string; mobileNumber: string }): Observable<any> {
    const url = `${endpoints.driverPage.driverUpdatePhoneUrl}/${driverId}/phone`;
    return this.http.put(url, body);
  }

  /**
   * Get invitation details by invitation ID
   * Used for viewing invited driver details in the "New" tab
   */
  getInvitationDetails(invitationId: string): Observable<any> {
    const url = `${endpoints.driverPage.invitationDetailsUrl}/${invitationId}`;
    return this.http.get(url);
  }

}
